// Questions people ask before signing up. Shown on the landing page and, word
// for word, as FAQ structured data there (search engines only accept it for
// questions that are visible on the page). Keep every answer true of the app.

export interface Faq {
  question: string;
  answer: string;
}

export const FAQS: Faq[] = [
  {
    question: 'How does TradePrep help me prepare for a trade exam?',
    answer:
      'You practise questions one at a time and see an explanation after each answer, sit timed mock exams, and see your results by topic so you know what to work on next. You choose how many questions, the time limit and the pass mark.',
  },
  {
    question: 'Who writes the questions?',
    answer:
      'Question banks in the Store are written by training providers and tradespeople. Providers add their credentials, such as a trade registration, for TradePrep to check, and every product is reviewed before it appears in the Store.',
  },
  {
    question: 'Can I try a question bank before I buy it?',
    answer: 'Many products include a free sample so you can try real questions first, and some are free. Look for the free sample on the product page.',
  },
  {
    question: 'How much does TradePrep cost?',
    answer:
      'Creating an account is free. Question banks in the Store are priced by their providers: some are free, some are a one-off purchase and some are a monthly subscription. The price is on each product page before you buy.',
  },
  {
    question: 'Can I study on my phone?',
    answer: "Yes. TradePrep works in your phone's browser, and you can add it to your home screen so it opens full screen like an app.",
  },
  {
    question: 'Can I make my own questions?',
    answer: 'Yes. You can create your own question banks, for example from your course notes, and practise from them like any other.',
  },
  {
    question: 'Is TradePrep official or endorsed by an exam body?',
    answer:
      'No. TradePrep is an independent study platform. It is not affiliated with or endorsed by any regulator, licensing board or examination body unless a product says so.',
  },
];
